import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'itl-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent implements OnChanges {
  @Input() disabled = false;
  @Input() public icon: 'alberta-dot';
  @Input() public color: '#000';

  @HostBinding('class.disabled') disabledStyle = false;

  ngOnChanges(_changes: SimpleChanges): void {
    this.disabledStyle = this.disabled;
  }
}
